import { LineReveal } from "./Reveal";
import { Eyebrow } from "./Bits";
import DotCluster from "./DotCluster";
import { motion } from "framer-motion";

export default function PageHeader({ label, titleLines, intro, image }) {
  return (
    <section className="relative overflow-hidden bg-[#070912] text-white pt-[74px]">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="h-full w-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#070912] via-[#070912]/85 to-[#070912]/55" />
        </div>
      )}
      <div className="absolute left-[-6%] top-1/4 h-80 w-80 glow-pink pointer-events-none" />
      <DotCluster className="absolute -top-10 right-0 h-[420px] w-[420px] opacity-60 pointer-events-none hidden md:block" count={70} />
      <div className="relative container-x pt-24 pb-24 md:pt-32 md:pb-28">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }}>
          <Eyebrow className="text-nead-cyan">{label}</Eyebrow>
        </motion.div>
        <h1 className="mt-6 font-display font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-[4.4rem] leading-[1.03] max-w-4xl">
          <LineReveal lines={titleLines} lineClassName="text-white" delay={0.15} />
        </h1>
        {intro && (
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.7 }}
            className="mt-7 max-w-2xl text-lg text-white/70 leading-relaxed"
          >
            {intro}
          </motion.p>
        )}
      </div>
      <div className="relative h-1.5 w-full grad-pink-cyan" />
    </section>
  );
}
